import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Knowledgebase } from '../../models/knowledgebase';
import { caseSelectOneObjectByQuery, userSelectOneObjectByQuery } from '../thunks/DBServiceThunks';
import { canEditCase } from '../../utils/permissions';

export const selectLegalDomainKnowledgebases = createSelector(
  [
    (state: RootState) => state.DBKnowledgebaseReducer.entities,
    (state: RootState, jurisdiction: string) => jurisdiction
  ],
  (entities, jurisdiction) => {
    return Object.values(entities).filter((kb): kb is Knowledgebase =>
      kb !== null && // Ensure kb is not null
      !kb.caseId && // Filter out KBs with a caseId
      kb.jurisdiction?.toUpperCase() === jurisdiction.toUpperCase()
    );
  }
);

/**
 * Memoized selector to check if the current user can edit the current case.
 * Returns true if user has editor role, false otherwise.
 * Uses memoization to avoid redundant calculations across components.
 */
export const selectCanEditCurrentCase = createSelector(
  [
    (state: RootState) => state.CaseReducer.currentCaseId,
    (state: RootState) => state.DBCaseReducer,
    (state: RootState) => state.DBUserReducer
  ],
  (currentCaseId, caseReducer, userReducer) => {
    const currentCase = caseSelectOneObjectByQuery(caseReducer, { _id: currentCaseId });
    const currentUser = userSelectOneObjectByQuery(userReducer, {});
    return canEditCase(currentCase, currentUser);
  }
);

